import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col bg-background-100">
      <SiteHeader />
      <main className="flex-1 w-full flex flex-col items-center justify-center text-center px-4 py-24">
        <span className="font-heading font-black text-[90px] md:text-[140px] leading-none text-background-300 select-none">
          404
        </span>
        <h1 className="mt-2 text-xl md:text-2xl font-bold text-foreground-900 font-heading">
          页面走丢啦
        </h1>
        <p className="mt-2 text-sm md:text-base text-foreground-500 max-w-md">
          你访问的页面不存在或已被移除，不妨回到首页，继续探索日韩与欧美的精彩影视内容。
        </p>
        <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-home-5-line" />
            返回首页
          </Link>
          <Link
            to="/category/movie"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-background-50 border border-background-300 text-sm font-medium text-foreground-700 hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-film-line" />
            浏览电影
          </Link>
        </div>
      </main>
    </div>
  );
}